/* corex-textil-editor-fotos.js · Fotos reales del producto en el personalizador.
   El editor y «Así queda puesta» pueden ser una silueta plana (productos sin fotos calibradas): aquí se enseña siempre
   la prenda de verdad.
   - Bloque «Fotos del producto» ([data-cte-fotos], en la columna de la vista previa y en la hoja móvil): foto principal
     del color elegido y tira de miniaturas (delante, detrás y lateral de ese color, y las de modelo del producto).
   - Miniatura «Foto real» junto al editor ([data-cte-fotomini]) para verla en móvil sin abrir paneles.
   - Visor a pantalla completa: deslizar o flechas para pasar, doble toque / clic o rueda para ampliar, arrastrar para
     moverse por la foto ampliada; Esc o ✕ para cerrar.
   Foto principal de un color: la imagen de su variante en Shopify (data.colors[].photo) o, si no tiene, la frontal del
   proveedor (data.packshots[color].face). Detrás y lateral: data.packshots. Modelo: data.fotos (imágenes del producto
   que no son de ninguna variante). attach(o) recibe { root, data } y devuelve { sync(color, flat) }: flat = la vista
   previa es la silueta plana (se rotula «Simulación sobre silueta» y la foto principal pasa a «Foto real de la prenda»). */
(function () {
  'use strict';

  var MAX_ZOOM = 4, DBL_ZOOM = 2.5, SWIPE_PX = 50, DBL_MS = 300;
  var LABEL = { face: 'Delante', back: 'Detrás', side: 'Lateral', fotos: 'Modelo' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* https o sin protocolo («//corexsport.com/cdn/…», como las da image_url de Shopify) */
  function isUrl(u) { return typeof u === 'string' && /^(https:)?\/\//i.test(u); }

  /* Fotos de un color: [{ src, thumb, label }], la principal primero; sin repetir. */
  function photosOf(data, colorName) {
    var c = (data.colors || []).filter(function (x) { return x.name === colorName; })[0] || {};
    var pk = (data.packshots || {})[colorName] || {}, out = [], seen = {};
    var add = function (src, thumb, label) {
      if (!isUrl(src) || seen[src]) return;
      seen[src] = true;
      out.push({ src: src, thumb: isUrl(thumb) ? thumb : src, label: label });
    };
    if (c.photo) add(c.photo, c.thumb, LABEL.face);
    else add(pk.face, pk.face, LABEL.face);
    add(pk.back, pk.back, LABEL.back);
    add(pk.side, pk.side, LABEL.side);
    (data.fotos || []).forEach(function (f) { add(f.src, f.thumb, LABEL.fotos); });
    return out;
  }

  function attach(o) {
    var root = o.root, data = o.data, list = [], color = null, flat = false, lb = null;

    function blockHtml() {
      if (!list.length) return '<h3 class="cte-step__t">Fotos del producto</h3><p class="cte-note">Este color no tiene foto.</p>';
      var main = list[0];
      return '<h3 class="cte-step__t">Fotos del producto</h3>' +
        '<button type="button" class="cte-fotos__main" data-cte-foto="0" aria-label="Ampliar la foto de ' + esc(color) + '">' +
        '<img src="' + esc(main.src) + '" alt="' + esc(color) + ': ' + esc(main.label.toLowerCase()) + '" loading="lazy" decoding="async"></button>' +
        '<p class="cte-fotos__cap">' + (flat ? 'Foto real de la prenda · ' : '') + esc(color) + '</p>' +
        (list.length > 1 ? '<div class="cte-fotos__strip" role="list">' + list.map(function (f, i) {
          return '<button type="button" role="listitem" class="cte-fotos__th" data-cte-foto="' + i + '" aria-label="' + esc(f.label) + ' (' + (i + 1) + ' de ' + list.length + ')">' +
            '<img src="' + esc(f.thumb) + '" alt="" loading="lazy" decoding="async"></button>';
        }).join('') + '</div>' : '');
    }
    function render() {
      var html = blockHtml();
      Array.prototype.forEach.call(root.querySelectorAll('[data-cte-fotos]'), function (el) { el.innerHTML = html; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-cte-flatnote]'), function (el) { el.hidden = !flat; });
      var mini = root.querySelector('[data-cte-fotomini]');
      if (mini) {
        mini.hidden = !list.length;
        if (list.length) mini.querySelector('img').src = list[0].thumb;
      }
    }
    function sync(c, isFlat) {
      var f = !!isFlat;
      if (c === color && f === flat) return;
      color = c; flat = f; list = photosOf(data, c);
      render();
      if (lb && !lb.el.hidden) open(0);
    }

    /* ---------- visor ---------- */
    function build() {
      var el = document.createElement('div');
      el.className = 'cte-lb';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Fotos del producto');
      el.innerHTML = '<div class="cte-lb__top"><span class="cte-lb__n" data-lb-n></span><button type="button" class="cte-lb__x" data-lb-x aria-label="Cerrar">✕</button></div>' +
        '<div class="cte-lb__view" data-lb-view><img class="cte-lb__img" data-lb-img alt="" draggable="false"></div>' +
        '<button type="button" class="cte-lb__nav cte-lb__nav--prev" data-lb-prev aria-label="Foto anterior">‹</button>' +
        '<button type="button" class="cte-lb__nav cte-lb__nav--next" data-lb-next aria-label="Foto siguiente">›</button>' +
        '<p class="cte-lb__cap" data-lb-cap></p>';
      root.appendChild(el);
      var s = { el: el, img: el.querySelector('[data-lb-img]'), view: el.querySelector('[data-lb-view]'), i: 0, z: 1, x: 0, y: 0, back: null };
      el.querySelector('[data-lb-x]').addEventListener('click', close);
      el.querySelector('[data-lb-prev]').addEventListener('click', function () { go(-1); });
      el.querySelector('[data-lb-next]').addEventListener('click', function () { go(1); });
      /* en el documento: tras arrastrar la foto el foco ya no está en el visor */
      document.addEventListener('keydown', function (e) {
        if (el.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowLeft') go(-1);
        else if (e.key === 'ArrowRight') go(1);
      });
      wireGestures(s);
      return s;
    }
    function apply() { lb.img.style.transform = 'translate(' + lb.x + 'px,' + lb.y + 'px) scale(' + lb.z + ')'; lb.view.classList.toggle('is-zoom', lb.z > 1); }
    /* Mantiene la foto ampliada dentro del visor. */
    function clamp() {
      var r = lb.view.getBoundingClientRect(), mx = Math.max(0, (lb.img.offsetWidth * lb.z - r.width) / 2), my = Math.max(0, (lb.img.offsetHeight * lb.z - r.height) / 2);
      lb.x = Math.max(-mx, Math.min(mx, lb.x)); lb.y = Math.max(-my, Math.min(my, lb.y));
    }
    /* Zoom z centrado en el punto (px, py) de la pantalla. */
    function zoomAt(z, px, py) {
      var r = lb.view.getBoundingClientRect(), cx = px - (r.left + r.width / 2), cy = py - (r.top + r.height / 2), k = z / lb.z;
      lb.x = cx - (cx - lb.x) * k; lb.y = cy - (cy - lb.y) * k; lb.z = z;
      if (z <= 1) { lb.z = 1; lb.x = 0; lb.y = 0; }
      clamp(); apply();
    }
    function wireGestures(s) {
      var pts = {}, start = null, lastTap = 0, pinch = null;
      s.view.addEventListener('pointerdown', function (e) {
        s.view.setPointerCapture(e.pointerId);
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(pts);
        if (ids.length === 2) {
          var a = pts[ids[0]], b = pts[ids[1]];
          pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), z: lb.z, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 };
          start = null;
        } else start = { x: e.clientX, y: e.clientY, ox: lb.x, oy: lb.y, t: Date.now() };
      });
      s.view.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(pts);
        if (pinch && ids.length === 2) {
          var a = pts[ids[0]], b = pts[ids[1]];
          zoomAt(Math.max(1, Math.min(MAX_ZOOM, pinch.z * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d)), pinch.cx, pinch.cy);
          return;
        }
        if (start && lb.z > 1) { lb.x = start.ox + e.clientX - start.x; lb.y = start.oy + e.clientY - start.y; clamp(); apply(); }
      });
      var up = function (e) {
        if (!pts[e.pointerId]) return;
        delete pts[e.pointerId];
        if (pinch) { if (!Object.keys(pts).length) pinch = null; return; }
        if (!start) return;
        var dx = e.clientX - start.x, dy = e.clientY - start.y, moved = Math.hypot(dx, dy) > 8;
        if (!moved) {
          var now = Date.now();
          if (now - lastTap < DBL_MS) { zoomAt(lb.z > 1 ? 1 : DBL_ZOOM, e.clientX, e.clientY); lastTap = 0; } else lastTap = now;
        } else if (lb.z === 1 && Math.abs(dx) > SWIPE_PX && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        start = null;
      };
      s.view.addEventListener('pointerup', up);
      s.view.addEventListener('pointercancel', up);
      s.view.addEventListener('wheel', function (e) {
        e.preventDefault();
        zoomAt(Math.max(1, Math.min(MAX_ZOOM, lb.z * (e.deltaY < 0 ? 1.2 : 1 / 1.2))), e.clientX, e.clientY);
      }, { passive: false });
    }
    function show(i) {
      lb.i = (i + list.length) % list.length;
      var f = list[lb.i];
      lb.z = 1; lb.x = 0; lb.y = 0; apply();
      lb.img.src = f.src;
      lb.img.alt = color + ': ' + f.label.toLowerCase();
      lb.el.querySelector('[data-lb-n]').textContent = (lb.i + 1) + ' / ' + list.length;
      lb.el.querySelector('[data-lb-cap]').textContent = color + ' · ' + f.label;
      var many = list.length > 1;
      lb.el.querySelector('[data-lb-prev]').hidden = !many;
      lb.el.querySelector('[data-lb-next]').hidden = !many;
    }
    function go(d) { if (list.length > 1) show(lb.i + d); }
    function open(i) {
      if (!list.length) return;
      lb = lb || build();
      if (lb.el.hidden) lb.back = document.activeElement;
      lb.el.hidden = false;
      document.documentElement.classList.add('cte-noscroll');
      show(i);
      lb.el.querySelector('[data-lb-x]').focus();
    }
    function close() {
      if (!lb || lb.el.hidden) return;
      lb.el.hidden = true;
      /* la hoja móvil también bloquea el scroll: solo se libera si no está abierta */
      var sheetOpen = Array.prototype.some.call(root.querySelectorAll('.cte-sheet'), function (s) { return !s.hidden; });
      if (!sheetOpen) document.documentElement.classList.remove('cte-noscroll');
      if (lb.back && lb.back.focus) lb.back.focus();
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cte-foto], [data-cte-fotomini]');
      if (!b || !root.contains(b)) return;
      open(b.hasAttribute('data-cte-foto') ? Number(b.dataset.cteFoto) || 0 : 0);
    });
    return { sync: sync, photosOf: function (c) { return photosOf(data, c); } };
  }

  window.CorexTextilFotos = { attach: attach, photosOf: photosOf };
})();
